module.exports = __webpack_public_path__ + "img/bf86a79.png";